(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6095],{

/***/ 965700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);


var LoaderIcon = function(props) {
    var waterSplashLoader = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "waterSplashLoader",
            style: props.style,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
            ]
        });
    };
    var ellipsis = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "ds-ellipsis-loader",
            style: props.style,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
            ]
        });
    };
    var _renderLoader = function(type) {
        switch(type){
            case "water_splash_loader":
                return waterSplashLoader();
            case "ellipsis":
            default:
                return ellipsis();
        }
    };
    return _renderLoader(props.type || "");
};
/* harmony default export */ __webpack_exports__["Z"] = (LoaderIcon);


/***/ }),

/***/ 917732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ getActiveTestimonialIndex; },
/* harmony export */   "C_": function() { return /* binding */ getImageWrapperStyles; },
/* harmony export */   "EX": function() { return /* binding */ getViewableTestimonials; },
/* harmony export */   "KG": function() { return /* binding */ getImageList; },
/* harmony export */   "Px": function() { return /* binding */ getAuthorImagePositionInfo; },
/* harmony export */   "S4": function() { return /* binding */ getAuthImageListMaxWidth; },
/* harmony export */   "Z$": function() { return /* binding */ scrollImageToConatinerCenter; },
/* harmony export */   "jF": function() { return /* binding */ getImageClassesL4; },
/* harmony export */   "l8": function() { return /* binding */ getStylesAndUtilsFromConfig; },
/* harmony export */   "p1": function() { return /* binding */ getWrapperStyles; },
/* harmony export */   "wy": function() { return /* binding */ getImageLimit; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(269396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);
/* harmony import */ var src_utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(186812);
/* harmony import */ var _Constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26763);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(575646);






function getImageLimit(isMobile, config) {
    if (!isMobile) {
        return config.DESKTOP;
    }
    return src_utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__/* .deviceWidth */ .o <= 360 ? config.MOBILE_XS : config.MOBILE;
}
function getImageClassesL4(isActive) {
    return isActive ? "" : "tw-opacity-70";
}
function getImageWrapperStyles(imageShape) {
    var index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var blobBorderRadius = [
        "30% 70% 70% 30% / 30% 47% 53% 70%",
        "54% 46% 70% 30% / 19% 79% 21% 81%",
        "87% 13% 60% 40% / 30% 93% 7% 70%",
        "67% 33% 16% 84% / 63% 52% 48% 37%",
        "72% 28% 69% 31% / 67% 57% 43% 33%", 
    ];
    switch(imageShape){
        case "square":
            return {
                aspectRatio: 1
            };
        case "portraitTall":
            return {
                aspectRatio: 2 / 3
            };
        case "portraitShort":
            return {
                aspectRatio: 3 / 4
            };
        case "landscape":
            return {
                aspectRatio: 3 / 2
            };
        case "landscapeWide":
            return {
                aspectRatio: 4 / 3
            };
        case "circle":
            return {
                aspectRatio: 1,
                borderRadius: "9999px"
            };
        case "blob":
            return {
                aspectRatio: 1,
                borderRadius: blobBorderRadius[index % 5]
            };
        case "arch":
            return {
                aspectRatio: 3 / 4,
                borderRadius: "9999px 9999px 0px 0px"
            };
        default:
            return {};
    }
}
function getViewableTestimonials(param) {
    var cardFrameConfig = param.cardFrameConfig, isCarousel = param.isCarousel, isTestimonialListingPage = param.isTestimonialListingPage, containerTracks = param.containerTracks, isProductTestmonial = param.isProductTestmonial, _viewAllItemsConfig = param.viewAllItemsConfig, viewAllItemsConfig = _viewAllItemsConfig === void 0 ? {} : _viewAllItemsConfig;
    var ref;
    var allTestimonials = (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.testimonialsList) || [];
    var visibleTestimonials = allTestimonials === null || allTestimonials === void 0 ? void 0 : (ref = allTestimonials.filter) === null || ref === void 0 ? void 0 : ref.call(allTestimonials, function(testimonial) {
        return (testimonial === null || testimonial === void 0 ? void 0 : testimonial.isVisible) !== undefined ? testimonial === null || testimonial === void 0 ? void 0 : testimonial.isVisible : true;
    });
    // max rows for grid -> 2,  if not listing page.
    var shouldTruncateList = !isCarousel && !isTestimonialListingPage;
    var showAllItem = (viewAllItemsConfig === null || viewAllItemsConfig === void 0 ? void 0 : viewAllItemsConfig.areAllItemsVisible) || false;
    return isProductTestmonial ? showAllItem ? visibleTestimonials : visibleTestimonials === null || visibleTestimonials === void 0 ? void 0 : visibleTestimonials.slice(0, containerTracks.numColumns * containerTracks.numRows) : shouldTruncateList ? visibleTestimonials === null || visibleTestimonials === void 0 ? void 0 : visibleTestimonials.slice(0, containerTracks.numColumns * 2) : visibleTestimonials;
}
/**
 * This function return the updated list after the array rotation.
 * if limit is L, then the array would contain 2*L-1 element.
 * with L-1 elements for each side(left and right to the active image(testimonial) )
 */ function getImageList(param) {
    var showRotation = param.showRotation, totalItems = param.totalItems, activeTestimonialIdx = param.activeTestimonialIdx, viewAbleImageLimit = param.viewAbleImageLimit, testimonialsData = param.testimonialsData, isProductTestimonial = param.isProductTestimonial;
    var startIndex;
    var endIndex;
    // return the original array if rotation is not required
    if (!showRotation) {
        startIndex = 0;
        endIndex = totalItems - 1;
    } else {
        // negative indexes means elements from the end of array (-1 -> last element).
        startIndex = activeTestimonialIdx - (viewAbleImageLimit - 1);
        endIndex = activeTestimonialIdx + (viewAbleImageLimit - 1);
    }
    var imageList = [];
    // loop for generating new image list
    for(var i = startIndex; i <= endIndex; i++){
        var ref, ref1;
        var testimonailIndex = (totalItems + i) % totalItems;
        var testimonialData = testimonialsData.at(testimonailIndex);
        imageList.push({
            mediaUrl: (isProductTestimonial ? testimonialData === null || testimonialData === void 0 ? void 0 : testimonialData.productImage : testimonialData === null || testimonialData === void 0 ? void 0 : (ref = testimonialData.authorMedia) === null || ref === void 0 ? void 0 : ref.link) || _Constants__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_IMAGE */ .UF,
            mediaType: (isProductTestimonial ? testimonialData === null || testimonialData === void 0 ? void 0 : testimonialData.productImage : testimonialData === null || testimonialData === void 0 ? void 0 : (ref1 = testimonialData.authorMedia) === null || ref1 === void 0 ? void 0 : ref1.type) || _Constants__WEBPACK_IMPORTED_MODULE_2__/* .MEDIA_TYPES.IMAGE */ .w_.IMAGE,
            index: testimonailIndex
        });
    }
    return imageList;
}
/**
 *  function to scroll image in case of  L4  to the center of it's conatiner.
 */ function scrollImageToConatinerCenter(param) {
    var element = param.element, _instantScroll = param.instantScroll, instantScroll = _instantScroll === void 0 ? false : _instantScroll, scrollerRef = param.scrollerRef, showLoader = param.showLoader, setShowLoader = param.setShowLoader;
    if (scrollerRef.current && element) {
        var container = scrollerRef.current;
        // half of container width
        var containerHalfWidth = container.offsetWidth / 2;
        // position of container
        var containerRect = container.getBoundingClientRect();
        var conatinerCenter = containerRect.left + containerHalfWidth;
        // postition of element
        var itemRect = element.getBoundingClientRect();
        // position of element's center
        var itemCenter = (itemRect.left + itemRect.right) / 2;
        // displacement of element's center from the container's center (element's center - conatiner's center)
        var positionFromCenter = itemCenter - conatinerCenter;
        // adjust the scroll position of element.
        container.scrollTo({
            left: container.scrollLeft + positionFromCenter,
            behavior: instantScroll ? "instant" : "smooth"
        });
        showLoader && setShowLoader(false);
    }
}
function getAuthorImagePositionInfo(param) {
    var pos = param.pos, isMobileAndL5 = param.isMobileAndL5;
    var positionInfo = {
        withAuthorInfo: pos === _Constants__WEBPACK_IMPORTED_MODULE_2__/* .TESTIMONIAL_IMAGE_POSITION.WITH_AUTHOR_INFO */ .eu.WITH_AUTHOR_INFO,
        top: pos === _Constants__WEBPACK_IMPORTED_MODULE_2__/* .TESTIMONIAL_IMAGE_POSITION.TOP */ .eu.TOP,
        bottom: pos === _Constants__WEBPACK_IMPORTED_MODULE_2__/* .TESTIMONIAL_IMAGE_POSITION.BOTTOM */ .eu.BOTTOM,
        left: pos === _Constants__WEBPACK_IMPORTED_MODULE_2__/* .TESTIMONIAL_IMAGE_POSITION.LEFT */ .eu.LEFT
    };
    if (isMobileAndL5 && positionInfo.left) {
        positionInfo = {
            withAuthorInfo: false,
            top: true,
            bottom: false,
            left: false
        };
    }
    return positionInfo;
}
function getActiveTestimonialIndex(param) {
    var carouselIndicatorConfigs = param.carouselIndicatorConfigs, totalItems = param.totalItems;
    return ((carouselIndicatorConfigs === null || carouselIndicatorConfigs === void 0 ? void 0 : carouselIndicatorConfigs.currentFocusedSectionItem) - 1) % totalItems;
}
function getAuthImageListMaxWidth(param) {
    var viewAbleImageLimit = param.viewAbleImageLimit, isSmartShape = param.isSmartShape, containerWidthSmartShape = param.containerWidthSmartShape, imageSizeActive = param.imageSizeActive, imageSizeInactive = param.imageSizeInactive, imageGap = param.imageGap;
    var itemsExceptActive = viewAbleImageLimit - 1;
    var widthForInactiveItems = itemsExceptActive * (isSmartShape ? containerWidthSmartShape : imageSizeInactive);
    var widthForGapInBetween = itemsExceptActive * imageGap;
    var widthForActiveItem = isSmartShape ? containerWidthSmartShape : imageSizeActive;
    return widthForInactiveItems + widthForGapInBetween + widthForActiveItem;
}
// function to get Testimonial card wrapper styles
function getWrapperStyles(param) {
    var showBorder = param.showBorder, listPresentationConfig = param.listPresentationConfig, isSelected = param.isSelected, shouldAdjustCardPaddingX = param.shouldAdjustCardPaddingX;
    var className = showBorder ? " tw-border tw-border-solid " : "";
    var style = {};
    style = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, style), {
        borderColor: showBorder ? listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.borderColor : "",
        backgroundColor: showBorder ? listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.backgroundColor : ""
    }), isSelected ? {
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "#2B74D8",
        backgroundColor: "#2B74D80F"
    } : {}, shouldAdjustCardPaddingX ? {
        paddingLeft: 20,
        paddingRight: 20
    } : {});
    return {
        style: style,
        className: className
    };
}
function getStylesAndUtilsFromConfig(param) {
    var isMobile = param.isMobile, cardFrameConfig = param.cardFrameConfig;
    var textSizeKey = !isMobile ? "textSizeDesktop" : "textSizeMobile";
    var headSizelineKey = !isMobile ? "headlineSizeDesktop" : "headlineSizeMobile";
    var imageWidthKey = !isMobile ? "imageSizeDesktop" : "imageSizeMobile";
    var textAlignmentStyle = (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getMappedProductTextAlign */ .sz)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.textAlign);
    var reviewStylesFromConfig = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getMappedproductsTextSize */ .Im)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig[textSizeKey]), (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getMappedProductCasing */ .TI)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.textCase), (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getMappedProductTextThickness */ .aA)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.textThickness), textAlignmentStyle), {
        color: cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.reviewColor
    });
    var headlineStylesFromConfig = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getMappedProductCasing */ .TI)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.headlineCase), (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getMappedproductsTextSize */ .Im)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig[headSizelineKey]), (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getMappedProductTextThickness */ .aA)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.headlineThickness)), {
        color: cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.headlineColor
    });
    var imageWidth = cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig[imageWidthKey];
    var isContentCenter = (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.textAlign) === "center";
    var showRatings = cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.showRatings;
    var showImage = cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.showImage;
    return {
        reviewStylesFromConfig: reviewStylesFromConfig,
        headlineStylesFromConfig: headlineStylesFromConfig,
        textAlignmentStyle: textAlignmentStyle,
        imageWidth: imageWidth,
        isContentCenter: isContentCenter,
        showRatings: showRatings,
        showImage: showImage
    };
}


/***/ }),

/***/ 575646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Im": function() { return /* binding */ getMappedproductsTextSize; },
/* harmony export */   "Ju": function() { return /* binding */ commonApiHeader; },
/* harmony export */   "TI": function() { return /* binding */ getMappedProductCasing; },
/* harmony export */   "aA": function() { return /* binding */ getMappedProductTextThickness; },
/* harmony export */   "sz": function() { return /* binding */ getMappedProductTextAlign; }
/* harmony export */ });
/* unused harmony export getTextSizeNum */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);

function getMappedproductsTextSize(sizeString) {
    var style = {};
    switch(sizeString){
        case "extraSmall":
            style.fontSize = "12px";
            style.lineHeight = "1.4";
            break;
        case "small":
            style.fontSize = "13px";
            style.lineHeight = "1.4";
            break;
        case "regular":
            style.fontSize = "14px";
            style.lineHeight = "1.4";
            break;
        case "medium":
            style.fontSize = "16px";
            style.lineHeight = "1.4";
            break;
        case "large":
            style.fontSize = "18px";
            style.lineHeight = "1.4";
            break;
        case "extraLarge":
            style.fontSize = "20px";
            style.lineHeight = "1.4";
            break;
        default:
            style.fontSize = "14px";
            style.lineHeight = "1.4";
            break;
    }
    return style;
}
function getMappedProductTextAlign(xAlignment) {
    var styles = {};
    switch(xAlignment){
        case "left":
            styles.textAlign = "left";
            break;
        case "center":
            styles.textAlign = "center";
            break;
        case "right":
            styles.textAlign = "right";
            break;
    }
    return styles;
}
function getMappedProductTextThickness(textThicness) {
    var styles = {};
    switch(textThicness){
        case "thin":
            styles.fontWeight = "300";
            break;
        case "regular":
            styles.fontWeight = "400";
            break;
        case "medium":
            styles.fontWeight = "500";
            break;
        case "semiBold":
            styles.fontWeight = "600";
            break;
        case "bold":
            styles.fontWeight = "700";
            break;
        default:
            styles.fontWeight = "400";
            break;
    }
    return styles;
}
function getMappedProductCasing(titleTextCase) {
    var style = {};
    switch(titleTextCase){
        case "none":
            style.textTransform = "none";
            break;
        case "capitalize":
            style.textTransform = "capitalize";
            break;
        case "uppercase":
            style.textTransform = "uppercase";
            break;
    }
    return style;
}
function getTextSizeNum(sizeString) {
    var textSizeStr = getMappedproductsTextSize(sizeString).fontSize;
    return Number(textSizeStr.replace("px", ""));
}
function commonApiHeader(authToken) {
    return {
        headers: {
            auth_token: authToken,
            app_os: "cfe",
            app_version: "0.1.0",
            "Content-Type": "application/json"
        }
    };
}


/***/ }),

/***/ 325480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ GlobalLoader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(626042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(185134);
/* harmony import */ var _globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(798388);
/* harmony import */ var src_redux_ssrStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(326706);
/* harmony import */ var src_components_Common_LoaderIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(965700);







var GlobalLoader = function(props) {
    var type = props.type, color = props.color;
    var store = (0,src_redux_ssrStore__WEBPACK_IMPORTED_MODULE_2__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.documentElement.style.setProperty("--loader-color", color);
    }, [
        color
    ]);
    switch(type){
        case "logo1":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().logo1)),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: store.logo_image,
                        style: {
                            height: "35px",
                            width: "35px"
                        }
                    })
                });
            }
        case "logo2":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().logo2)),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: store.logo_image,
                        style: {
                            height: "35px",
                            width: "35px"
                        }
                    })
                });
            }
        case "loader1":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    version: "1.1",
                    id: "L9",
                    xmlns: "http://www.w3.org/2000/svg",
                    x: "0px",
                    y: "0px",
                    width: "65px",
                    height: "65px",
                    viewBox: "0 0 100 100",
                    enableBackground: "new 0 0 0 0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: color,
                        d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                            attributeName: "transform",
                            attributeType: "XML",
                            type: "rotate",
                            dur: "1s",
                            from: "0 50 50",
                            to: "360 50 50",
                            repeatCount: "indefinite"
                        })
                    })
                });
            }
        case "loader2":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    version: "1.1",
                    id: "L5",
                    xmlns: "http://www.w3.org/2000/svg",
                    x: "0px",
                    y: "0px",
                    width: "35px",
                    height: "35px",
                    viewBox: "-20 0 100 100",
                    enableBackground: "new 0 0 0 0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "6",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 15 ; 0 -15; 0 15",
                                repeatCount: "indefinite",
                                begin: "0.1"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "30",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 10 ; 0 -10; 0 10",
                                repeatCount: "indefinite",
                                begin: "0.2"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "54",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.3"
                            })
                        })
                    ]
                });
            }
        case "loader3":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().loader3), "tw-h-[35px] tw-w-[35px]")
                });
            }
        case "loader4":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    version: "1.1",
                    id: "L4",
                    xmlns: "http://www.w3.org/2000/svg",
                    x: "0px",
                    y: "0px",
                    width: "35px",
                    height: "35px",
                    viewBox: "-20 0 100 100",
                    enableBackground: "new 0 0 0 0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "6",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animate", {
                                attributeName: "opacity",
                                dur: "1s",
                                values: "0;1;0",
                                repeatCount: "indefinite",
                                begin: "0.1"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "26",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animate", {
                                attributeName: "opacity",
                                dur: "1s",
                                values: "0;1;0",
                                repeatCount: "indefinite",
                                begin: "0.2"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "46",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animate", {
                                attributeName: "opacity",
                                dur: "1s",
                                values: "0;1;0",
                                repeatCount: "indefinite",
                                begin: "0.3"
                            })
                        })
                    ]
                });
            }
        case "loader5":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().loader5), "tw-h-[16px] tw-w-[35px]")
                });
            }
        default:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Common_LoaderIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props));
            }
    }
};


/***/ }),

/***/ 826061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ ADDITIONAL_PAGE_TYPE; },
/* harmony export */   "y": function() { return /* binding */ LAYOUT_TYPE; }
/* harmony export */ });
var ADDITIONAL_PAGE_TYPE = {
    BLOG: "blog",
    AI_BLOG: "ai-blog",
    NEW_BLOG: "NewBlog",
    TESTIMONIAL: "testimonial",
    HOME: "home",
    NEW_TESTIMONIALS: "Testimonials"
};
var LAYOUT_TYPE = {
    GRID: "grid",
    CAROUSEL: "carousel"
};


/***/ }),

/***/ 185134:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logo1":"globalLoader_logo1__U4pxQ","logo-1":"globalLoader_logo-1__07zYZ","logo2":"globalLoader_logo2__eivVl","loader-3":"globalLoader_loader-3__8hklP","loader3":"globalLoader_loader3__m47Bj","loader5":"globalLoader_loader5__6NXRf","loader-5-1":"globalLoader_loader-5-1__pESNT","loader-5-2":"globalLoader_loader-5-2__VgxuZ"};

/***/ })

}]);